import React, { Component } from 'react'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingColorConsumer } from 'context/MappingColorContext'
import MappingColorList from 'components/MappingColorList'

type MappingColorProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingColor extends Component<MappingColorProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingColorConsumer>
        {({ fetching, mappingColors, pagination, requestMappingColorList }) => {

          return <MappingColorList permissions={permissions} loading={fetching} mappingColors={mappingColors} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingColors={requestMappingColorList} />
        }}
      </MappingColorConsumer>
    )
  }
}
